/**
 * Globalny plik konfiguracyjny dla gry
 * Zawiera wszystkie parametry, które mogą być modyfikowane
 */

// Parametry czołgu
export const TANK_CONFIG = {
  // Parametry ruchu
  MOVEMENT: {
    MAX_SPEED: 7.0, // Maksymalna prędkość (jednostek/s) - zwiększona dla lepszej grywalności
    MAX_SPEED_KMH: 70, // Maksymalna prędkość (km/h) - realistyczna dla nowoczesnego czołgu
    ACCELERATION: 0.99, // Przyspieszenie (jednostek/s²) - zwiększone, ale wciąż realistyczne
    DECELERATION: 0.4, // Hamowanie (jednostek/s²) - szybsze niż przyspieszenie, ale wciąż realistyczne
    TURN_SPEED: 0.6, // Prędkość skrętu (rad/s) - dostosowana
    MAX_TURN_SPEED: 0.04,
    REVERSE_SPEED_FACTOR: 0.6, // Współczynnik prędkości cofania
    BOOST_FACTOR: 1.3, // Współczynnik przyspieszenia boost
    SPEED_FACTOR: 10.0, // Współczynnik konwersji prędkości na km/h - dostosowany (70/0.8 = 87.5)
    MUD_MAX_SPEED: 2.5, // Maksymalna prędkość w błocie - połowa normalnej prędkości
    HANDBRAKE_DECELERATION: 0.5, // Hamowanie hamulcem ręcznym (jednostek/s²) - mocniejsze hamowanie
    HANDBRAKE_TURN_BOOST: 2.0, // Zwiększenie prędkości skrętu podczas hamulca ręcznego
    // Parametry śladów kół
    TRACK_WIDTH: 1.6, // Szerokość między gąsienicami
    MIN_SPEED_FOR_TRAILS: 0.05, // Minimalna prędkość do tworzenia śladów
    MIN_SPEED_FOR_HANDBRAKE_TRAILS: 0.08, // Minimalna prędkość do tworzenia śladów przy hamulcu
    MAX_BRAKE_MARKS: 100, // Maksymalna liczba śladów hamowania
    TRAIL_FADE_TIME: 5000, // Czas zanikania śladów w ms
  },

  // Parametry wieży
  TURRET: {
    ROTATION_SPEED: 2.0, // Prędkość obrotu wieży (rad/s)
    ROTATION_ACCELERATION: 4.0, // Przyspieszenie obrotu wieży
    ROTATION_DECELERATION: 8.0, // Hamowanie obrotu wieży
    BARREL_ELEVATION_SPEED: 0.19, // Prędkość podnoszenia lufy (rad/s)
    BARREL_MAX_ELEVATION: 0.2, // Maksymalne podniesienie lufy (45 stopni)
    BARREL_MIN_ELEVATION: -0.22, // Minimalne podniesienie lufy (-30 stopni)
  },

  // Parametry strzelania
  SHOOTING: {
    COOLDOWN: 700, // Czas przeładowania (ms)
    RECOIL_STRENGTH: 0.4, // Siła odrzutu
    RECOIL_RECOVERY: 0.1, // Szybkość powrotu po odrzucie
    PROJECTILE_DAMAGE: 55, // Base damage from projectile hit 25
    PROJECTILE_DAMAGE_RADIUS: 2, // Blast radius for projectile damage
    PROJECTILE_DAMAGE_FALLOFF: 0.5, // Damage reduction per unit of distance from center
  },

  // Parametry zdrowia
  HEALTH: {
    ARMOR: 10, // Pancerz
    DAMAGE_RESISTANCE: 0.2, // Współczynnik odporności na obrazenia
    MAX_HEALTH: 100, // Maksymalne zdrowie czołgu
    COLLISION_DAMAGE: 10, // Obrażenia przy kolizji z innym czołgiem
    HEALTH_BAR_COLORS: {
      HIGH: 0x00ff00, // Kolor dla wysokiego zdrowia (zielony)
      MEDIUM: 0xffff00, // Kolor dla średniego zdrowia (żółty)
      LOW: 0xff0000, // Kolor dla niskiego zdrowia (czerwony)
    },
  },
};

// Parametry pocisków IS IT REALLY USED?
export const PROJECTILE_CONFIG = {
  SPEED: 1.0, // Prędkość pocisku
  RANGE: 50, // Zasięg pocisku
  SIZE: 0.1, // Rozmiar pocisku
  TRAIL_LENGTH: 10, // Długość śladu pocisku
};

// Parametry kamery
export const CAMERA_CONFIG = {
  MIN_DISTANCE: 5, // Minimalna odległość kamery
  MAX_DISTANCE: 20, // Maksymalna odległość kamery
  DEFAULT_DISTANCE: 10, // Domyślna odległość kamery
  ZOOM_SPEED: 0.001, // Szybkość przybliżania/oddalania
  BASE_FOV: 75, // Podstawowe pole widzenia
  SPEED_FOV_FACTOR: 15, // Współczynnik zmiany FOV w zależności od prędkości
};

// Parametry środowiska
export const ENVIRONMENT_CONFIG = {
  // Parametry kolizji
  COLLISION: {
    TANK_RADIUS: 1.5, // Promień kolizji czołgu
    TANK_VS_TANK_RADIUS: 2.0, // Promień kolizji między dwoma czołgami
    MIN_SPEED_TO_BREAK_TREE: 1.0, // Minimalna prędkość do złamania drzewa
    SPEED_REDUCTION_ON_TREE_BREAK: 0.7, // Współczynnik redukcji prędkości po złamaniu drzewa
    PUSHBACK_STRENGTH: 0.15, // Zwiększona siła odpychania przy kolizji czołgów
    SPEED_REDUCTION_ON_COLLISION: 0.5, // Współczynnik redukcji prędkości po kolizji
    MIN_COLLISION_SPEED: 0.01, // Minimalna prędkość do wykrycia kolizji
    COLLISION_DAMAGE_FACTOR: 0.2, // Współczynnik obrażeń przy kolizji (zależny od prędkości)
    COLLISION_BOUNCE_FACTOR: 0.4, // Współczynnik odbicia przy kolizji
    RANDOM_PUSHBACK_FACTOR: 0.15, // Losowy czynnik w kierunku odpychania
    ROCK_COLLISION_THRESHOLD: 0.2, // Próg prędkości dla aktywacji odbicia od kamienia
  },

  // Parametry drzew
  TREE: {
    FALL_DURATION: 1000, // Czas trwania animacji upadku drzewa (ms)
    BREAKING_SOUND_ENABLED: true, // Czy odtwarzać dźwięk łamania drzewa
  },

  GRASS: {
    BASE_DENSITY: 20.0, // Bazowa gęstość trawy
    GRASS_HEIGHT: 0.08, // Wysokość trawy
    GRASS_WIDTH: 0.05, // Szerokość trawy
  },

  // Parametry błota
  MUD: {
    RADIUS: 3, // Promień obszaru błota
    SPEED_MULTIPLIER: 0.5, // Mnożnik prędkości w błocie
  },

  // Parametry nieba
  SKY: {
    cubeMapSize: 1024, // Rozmiar tekstury skyboxa
    cloudSpeed: 0.0000006, // Prędkość ruchu chmur
    cloudDensity: 0.3, // Bazowa gęstość chmur (0-1)
    cloudScale: 0.5, // Bazowa skala chmur
    skyColor: 0x4a9ee3, // Bardziej intensywny błękit nieba
    cloudColor: 0xffffff, // Kolor chmur (biały)
    horizonColor: 0xadd8e6, // Kolor horyzontu (jaśniejszy błękit)
    fogNear: 30, // Bazowa odległość początku mgły
    fogFar: 150, // Bazowa odległość końca mgły
    // Mnożniki dla różnych poziomów jakości
    qualityMultipliers: {
      low: {
        cloudDensity: 0.5, // 50% bazowej gęstości chmur
        cloudScale: 0.3, // 30% bazowej skali chmur
        fogDensity: 0.3, // 30% bazowej gęstości mgły
        fogNearMultiplier: 0.6, // Zmniejszona odległość początku mgły
        fogFarMultiplier: 0.6, // Zmniejszona odległość końca mgły
      },
      medium: {
        cloudDensity: 0.7, // 70% bazowej gęstości chmur
        cloudScale: 0.6, // 60% bazowej skali chmur
        fogDensity: 0.6, // 60% bazowej gęstości mgły
        fogNearMultiplier: 0.8, // Średnia odległość początku mgły
        fogFarMultiplier: 0.8, // Średnia odległość końca mgły
      },
      high: {
        cloudDensity: 1.0, // 100% bazowej gęstości chmur
        cloudScale: 1.0, // 100% bazowej skali chmur
        fogDensity: 1.0, // 100% bazowej gęstości mgły
        fogNearMultiplier: 1.0, // Pełna odległość początku mgły
        fogFarMultiplier: 1.0, // Pełna odległość końca mgły
      },
    },
  },

  // Parametry interwału aktualizacji chunków
  CHUNK_UPDATE_INTERVAL: 5000, // Co ile ms aktualizować chunki podczas ruchu (500ms = 0.5s)
  UPDATE_THROTTLE: 100, // Minimalny czas pomiędzy aktualizacjami (ms)
};

// Parametry HUD
export const HUD_CONFIG = {
  SPEED_THRESHOLDS: {
    LOW: 20, // Próg niskiej prędkości (km/h)
    MEDIUM: 35, // Próg średniej prędkości (km/h)
    HIGH: 50, // Próg wysokiej prędkości (km/h)
  },
  PING_THRESHOLDS: {
    GOOD: 50, // Dobry ping (ms)
    MEDIUM: 100, // Średni ping (ms)
    HIGH: 200, // Wysoki ping (ms)
  },
  COLORS: {
    LOW_SPEED: "white", // Kolor dla niskiej prędkości
    MEDIUM_SPEED: "#ffff00", // Kolor dla średniej prędkości
    HIGH_SPEED: "#ff9900", // Kolor dla wysokiej prędkości
    VERY_HIGH_SPEED: "#ff3333", // Kolor dla bardzo wysokiej prędkości
    PING_GOOD: "#00ff00", // Kolor dla dobrego pingu
    PING_MEDIUM: "#ffff00", // Kolor dla średniego pingu
    PING_HIGH: "#ff9900", // Kolor dla wysokiego pingu
    PING_VERY_HIGH: "#ff3333", // Kolor dla bardzo wysokiego pingu
  },
};

// Parametry myszy
export const MOUSE_CONFIG = {
  SENSITIVITY: 0.001, // Czułość myszy
  MAX_VELOCITY: Math.PI, // Maksymalna prędkość ruchu myszy
};

// Konfiguracja sieci
export const NETWORK_CONFIG = {
  SERVER_URL: (() => {
    if (window.location.hostname === "localhost") {
      return "http://localhost:3011";
    } else {
      // W produkcji zawsze używamy HTTPS
      return `https://${window.location.host}`;
    }
  })(),
  RECONNECTION_ATTEMPTS: 5, // Liczba prób ponownego połączenia
  RECONNECTION_DELAY: 1000, // Opóźnienie między próbami ponownego połączenia (ms)
  TIMEOUT: 5000, // Timeout połączenia (ms)
  PING_UPDATES: 5000, // update every 5000ms
};

// Konfiguracja strefy respawnu
export const RESPAWN_ZONE_CONFIG = {
  SIZE: 25, // Rozmiar strefy respawnu (kwadrat)
  COLLISION_DISABLED: true, // Czy kolizje są wyłączone w strefie respawnu
  SAFE_TIME: 5000, // Czas w ms, przez który czołg jest chroniony po respawnie
  RESPAWN_TIME: 5000, // Czas odnowienia czołgu (ms)
};

// Konfiguracja billboardów
export const CLIENT_BILLBOARD_CONFIG = {
  CLICK_COOLDOWN: 3000, // Czas w ms, przez który billboard nie reaguje na interakcje po poprzedniej interakcji
  INTERACTION_EFFECT_DURATION: 300, // Czas trwania efektu wizualnego po interakcji (ms)
  TARGET_SIZE_FACTOR: 0.8, // Współczynnik rozmiaru celownika względem rozmiaru czcionki
  RAYCASTER_ANGLE_OFFSET: 0.1, // Kąt odchylenia dodatkowych raycastów (w radianach)
  POSITION: {
    DEFAULT_HEIGHT: 5.0, // Domyślna wysokość billboardu nad ziemią
  },
  // Dodajemy brakujące właściwości z BILLBOARD_CONFIG z pakietu shared
  DEFAULT_WIDTH: 10, // Domyślna szerokość billboardu
  DEFAULT_HEIGHT: 5, // Domyślna wysokość billboardu
  DEFAULT_TEXT_COLOR: "#000000", // Domyślny kolor tekstu
  DEFAULT_BG_COLOR: "#FFFFFF", // Domyślny kolor tła
  DEFAULT_FONT_SIZE: 0.5, // Domyślny rozmiar czcionki
};

export const AIRPLANE_CONFIG = {
  SPEED: 0.2,
  ALTITUDE: 30,
  MIN_ALTITUDE: 20, // Minimalna wysokość lotu
  WAVE_AMPLITUDE: 0.25, // Amplituda falowania
  WAVE_FREQUENCY: 0.5, // Częstotliwość falowania
  BANNER_WIDTH: 30,
  BANNER_HEIGHT: 5,
  REFRESH_INTERVAL: 100, // ms
  COLORS: {
    AIRPLANE_BODY: 0xcccccc,
    AIRPLANE_WINGS: 0xbbbbbb,
    BANNER_BACKGROUND: 0xffffff,
    BANNER_TEXT: 0xff0000,
    BANNER_BORDER: 0x000000,
    ROPES: 0x000000,
  },
};

export const COLORS = {
  sky: 0xB0E0E6,      // Slightly more vibrant Light Blue (Powder Blue)
  ground: 0xF5E8C7,    // Lighter, warmer Sandy Beige
  platform: 0xA0C0C0,  // More distinct Teal for platform edge
  treeTrunk: 0xA0522D, // Sienna (warmer brown)
  treeLeaves: 0x5A9A5A, // Softer, more vibrant Muted Green
  trunkOutline: 0x443731, // Ciemniejszy brązowy
  leavesOutline: 0x1b3a0a, // Ciemniejszy zielony
  tankBody: 0xE0D5A0,   // Lighter, warmer Pale Khaki
  tankTurret: 0xD0C590, // Slightly darker but warmer Tan
  tankTracks: 0x4A4A4A, // Darker Gray for contrast
  tankBarrel: 0x3A3A3A, // Darker Gray for barrel
  mountain: 0xF5B28A,   // Warmer Sandy Brown
  mountainSnow: 0xF8F8F8,// Slightly off-white Snow
  cloud: 0xF0F0F0,      // Slightly off-white for clouds
  rock: 0xB0B0B0,       // Lighter Gray for rocks
  projectile: 0xFFFFAA,  // Pale Yellow for projectiles
  edge: 0x333333,       // Softer dark gray for edges (less harsh than black)
}
